import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { selectVacancies } from '../selectors/vacancies';
import { prepareFilterValues } from '../utils/prepareFilterValues';
import { setSelectedFilters } from '../actions/vacancies';
import { qsKeyAsQSFilter } from '../constants/queryStringFilters';
import { EQueryStringFilters } from '../types/queryStringFilters';
import { TThunkDispatch } from '../types/redux';
import { IVacanciesFiltersV2Schema } from '../common/repositories/job-vacancies-backend/entities/filters/VacanciesFiltersV2Schema';

/**
 * Синхронизирует фильтры с qs
 */
export const useQueryStringParams = () => {
  const dispatch = useDispatch<TThunkDispatch>();
  const { filters, selectedFilters } = useSelector(selectVacancies);
  const [isInitialized, setIsInitialized] = useState(false);

  /**
   * Устанавливает фильтры в сторе по значениям гет-параметров
   * в адресной строке однократно при инициализации
   */
  useEffect(() => {
    const url = new URL(window.location.href);

    for (const [qsKey, qsValue] of url.searchParams.entries()) {
      const filterName = qsKeyAsQSFilter[qsKey as EQueryStringFilters];

      if (!filterName || !qsValue) {
        continue;
      }

      const selectedOptions = prepareFilterValues({
        filterName,
        qsValues: qsValue.split(','),
        filters,
      });

      if (!selectedOptions.length) {
        continue;
      }

      dispatch(setSelectedFilters({ filterName, selectedOptions }));
    }

    setIsInitialized(true);

    return () => {
      setIsInitialized(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /**
   * Устанавливает фильтры в адресной строке при изменении значений фильтров стора
   */
  useEffect(() => {
    if (!isInitialized) {
      return;
    }

    const url = new URL(window.location.origin + window.location.pathname);

    Object.keys(selectedFilters).map((filterName: keyof IVacanciesFiltersV2Schema) => {
      const filter = selectedFilters[filterName];

      if (filter?.length) {
        url.searchParams.set(filterName, filter.join(','));
      }
    });

    window.history.replaceState({}, '', url);
  }, [isInitialized, selectedFilters]);
};
